module.exports = __webpack_public_path__ + "static/media/logo-purple.101ec86c.png";